"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "mockResponseData", {
    enumerable: true,
    get: function() {
        return mockResponseData;
    }
});
const _Actorjson = /*#__PURE__*/ _interop_require_default(require("./Actor.json"));
const _Filmjson = /*#__PURE__*/ _interop_require_default(require("./Film.json"));
const _Producerjson = /*#__PURE__*/ _interop_require_default(require("./Producer.json"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const mockResponseData = {
    Actor: _Actorjson.default,
    Film: _Filmjson.default,
    Producer: _Producerjson.default
};
